import React from 'react'
import "./Footer.css"
import { NavLink } from 'react-router-dom'
import { FaPhone, FaCertificate, FaExchangeAlt, FaMapMarkerAlt, FaYoutube, FaInstagram, FaTwitter, FaFacebook } from 'react-icons/fa'
import logo from "../../Assets/Images/logo.png"

const Footer = () => {
    // Company information data
    const companyInfo = {
        name: "Trillion Stock Research",
        description: "Trillion Stock Research is a SEBI-registered investment advisory firm providing comprehensive technical analysis of the market through professional research analyst.",
        contact: {
            phone: "+91 9977555378",
            sebiNumber: "SEBI NO: INH000020129",
            bseNumber: "BSE Enlistment No.: 6528",
            address: "200 Sector A Suryadev Nagar, Indore, Madhya Pradesh, 452012"
        }
    };

    // Navigation links organized by category
    const navigationLinks = {
        main: [
            { to: "/", label: "Home" },
            { to: "/about", label: "About Us" },
            { to: "/services", label: "Services" },
            { to: "/performance", label: "Performance" },
            { to: "/contact", label: "Ask a Professional" },
            { to: "/pricing", label: "Pricing" },
            { to: "/payments", label: "Payments" }
        ],
        legal: [
            { to: "/complaints", label: "Complaints" },
            { to: "/terms", label: "Terms & Conditions" },
            { to: "/policy", label: "Policy" },
            { to: "/disclosure", label: "SEBI Disclosure" },
            { to: "/disclaimer", label: "Disclaimer" }
        ]
    };

    // Support links
    const supportLinks = [
        { to: "/contact", label: "Ask a Professional" },
        { to: "/suitability", label: "Suitability" },
        { to: "/assessment", label: "Assessment" },
        { to: "/risk-profit", label: "Risk Profit" },
        { to: "/privacy", label: "Privacy Policy" },
        { to: "/refund", label: "Refund Policy" },
        { to: "/investor", label: "Investor" },
        { to: "/charter", label: "Charter IA" }
    ];

    // Social media links
    const socialLinks = [
        { to: "#", icon: FaYoutube, className: "youtube" },
        { to: "#", icon: FaInstagram, className: "instagram" },
        { to: "#", icon: FaTwitter, className: "twitter" },
        { to: "#", icon: FaFacebook, className: "facebook" }
    ];

    // Contact item component
    const ContactItem = ({ icon: Icon, children }) => (
        <div className="trillion-contact-item">
            <Icon />
            <span>{children}</span>
        </div>
    );

    // Navigation column component
    const NavigationColumn = ({ title, links }) => (
        <div className="trillion-footer-column">
            <h3>{title}</h3>
            <ul>
                {links.map((link, index) => (
                    <li key={index}>
                        <NavLink to={link.to}>{link.label}</NavLink>
                    </li>
                ))}
            </ul>
        </div>
    );

    // Social link component
    const SocialLink = ({ link }) => {
        const Icon = link.icon;
        return (
            <NavLink to={link.to} className={`trillion-social-link ${link.className}`}>
                <Icon />
            </NavLink>
        );
    };

    return (
        <footer className="trillion-footer">
            <div className="trillion-footer-container">
                {/* Main Footer Content */}
                <div className="trillion-footer-main">
                    {/* Company Information Section */}
                    <div className="trillion-footer-brand">
                        {/* Logo and Company Name */}
                        <div className="trillion-footer-logo">
                            <img src={logo} alt={companyInfo.name} />
                            <h2>{companyInfo.name}</h2>
                        </div>
                        
                        {/* Company Description */}
                        <p className="trillion-footer-description">
                            {companyInfo.description}
                        </p>
                        
                        {/* Contact Information */}
                        <div className="trillion-footer-contact">
                            <ContactItem icon={FaPhone}>
                                {companyInfo.contact.phone}
                            </ContactItem>
                            <ContactItem icon={FaCertificate}>
                                {companyInfo.contact.sebiNumber}
                            </ContactItem>
                            <ContactItem icon={FaExchangeAlt}>
                                {companyInfo.contact.bseNumber}
                            </ContactItem>
                            <ContactItem icon={FaMapMarkerAlt}>
                                {companyInfo.contact.address}
                            </ContactItem>
                        </div>
                        
                        {/* Social Media Links */}
                        <div className="trillion-footer-social">
                            {socialLinks.map((link, index) => (
                                <SocialLink key={index} link={link} />
                            ))}
                        </div>
                    </div>

                    {/* Navigation Links Section */}
                    <div className="trillion-footer-links">
                        {/* Main Navigation */}
                        <NavigationColumn 
                            title="Site Navigation" 
                            links={navigationLinks.main} 
                        />
                        
                        {/* Legal & Policy Links */}
                        <NavigationColumn 
                            title="Legal & Policy" 
                            links={navigationLinks.legal} 
                        />

                        {/* Support Links */}
                                <NavigationColumn
          title="Support"
          links={supportLinks}
        />
        <NavigationColumn
          title="Regulatory"
          links={[
            { label: "SEBI Disclosure", to: "/disclosure" },
            { label: "Investor Charter", to: "/investor-charter" }
          ]}
        />
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="trillion-footer-bottom">
                    <p>&copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer